// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__Eu6-p","colMin":"styles_colMin__2F_eO","colCheckbox":"styles_colCheckbox__3_BA5"};